import { render, staticRenderFns } from "./ApproveAppointment.vue?vue&type=template&id=e93d4584&scoped=true"
import script from "./ApproveAppointment.vue?vue&type=script&lang=js"
export * from "./ApproveAppointment.vue?vue&type=script&lang=js"
import style0 from "./ApproveAppointment.vue?vue&type=style&index=0&id=e93d4584&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93d4584",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e93d4584')) {
      api.createRecord('e93d4584', component.options)
    } else {
      api.reload('e93d4584', component.options)
    }
    module.hot.accept("./ApproveAppointment.vue?vue&type=template&id=e93d4584&scoped=true", function () {
      api.rerender('e93d4584', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/appointment-actions/ApproveAppointment.vue"
export default component.exports